const SET_PAGE = (state, data) => {
  if (data.tree) {
    data.tree.forEach(item => {
      item.children = []
    })
  }

  state.page = data

  if (state.isPublic) {
    state.mode = data.view_mode
  }
}

const REMOVE_PAGE = (state, id) => {
  const idx = state.pages.findIndex(x => x.id === id)

  if (idx != -1) {
    state.pages.splice(idx, 1)
  }
}

const SET_TEXT = (state, data) => {
  if (typeof state.page.page_texts[0] !== 'undefined') {
    state.page.page_texts[0].text = data.text
  } else {
    state.page.page_texts.push({
      page_id: data.pageId,
      bundle_id: data.bundleId,
      text: data.text
    })
  }
}

const SET_PAGES = (state, data) => {
  state.pages = data
}

const PUSH_PAGE = (state, data) => {
  state.pages.push(data)
}

const RESET_PAGE = (state) => {
  state.page = null
}

const REMOVE_ORPHAN = (state, ids) => {
  ids.forEach(id => {
    const idx = state.page.orphans.findIndex(x => x.id === id)

    if (idx !== -1) {
      state.page.orphans.splice(idx, 1)
    }
  })
}

const EXPAND_TREE = (state, data) => {
  const findAndUpdateNode = (values, path) => {
    const valueId = path.shift()
    const value = values.find(x => x.id === valueId)

    if (path.length === 0) {
      if (value) {
        data.children.forEach(child => {
          child.children = []
        })

        value.children = data.children
      }
    } else {
      findAndUpdateNode(value.children, path)
    }
  }

  findAndUpdateNode(state.page.tree, data.path)
}

const SET_ACTIVE_STATE = (state, activeState) => {
  state.page.is_active = activeState
}

const SWITCH_MODE = (state) => {
  state.page.tree.forEach(item => { item.children = [] })
  state.mode = (state.mode === 'grid') ? 'tree' : 'grid'
}

const SET_PUBLIC = (state, isPublic) => {
  state.isPublic = isPublic
}

export default {
  SET_PAGE,
  SET_TEXT,
  SET_PAGES,
  PUSH_PAGE,
  SET_PUBLIC,
  RESET_PAGE,
  EXPAND_TREE,
  SWITCH_MODE,
  REMOVE_PAGE,
  REMOVE_ORPHAN,
  SET_ACTIVE_STATE
}
